import {
  Coffee, Cookie, Salad, Sun, Moon as MoonIcon, CupSoda, UtensilsCrossed, Package, Gift,
} from "lucide-react";

/** Lucide components keyed by the icon name stored on each meal type. */
export const ICON_MAP = {
  Coffee, Cookie, Salad, Sun, Moon: MoonIcon, CupSoda, UtensilsCrossed, Package, Gift,
};

/** "14:30" -> "2:30 PM". Returns "" for empty input. */
export const formatTime12 = (time24) => {
  if (!time24) return "";
  const [h, m] = time24.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 || 12;
  return `${h12}:${String(m).padStart(2, "0")} ${ampm}`;
};

/**
 * The eight fixed meal categories. Not user-editable — the backend seeds the
 * same list. Adding one here without adding it there will not persist.
 */
export const DEFAULT_MEAL_TYPES = [
  { value: "Breakfast", icon: "Coffee", color: "bg-amber-500/10 text-amber-600" },
  { value: "AM Break", icon: "Cookie", color: "bg-orange-500/10 text-orange-600" },
  { value: "Lunch", icon: "Salad", color: "bg-green-500/10 text-green-600" },
  { value: "PM Break", icon: "CupSoda", color: "bg-blue-500/10 text-blue-600" },
  { value: "Dinner", icon: "Sun", color: "bg-purple-500/10 text-purple-600" },
  { value: "All Day Snacks", icon: "Moon", color: "bg-rose-500/10 text-rose-600" },
  { value: "All Day Supplies", icon: "Package", color: "bg-teal-500/10 text-teal-600" },
  { value: "Goodies Bag", icon: "Gift", color: "bg-pink-500/10 text-pink-600" },
];
